/* eslint-disable @typescript-eslint/no-unused-vars */
import { isEqualWith } from "lodash";
import { useAppSelector } from "hooks";
import SingleItems from "./lib/SingleItems";
import { useWebStoreContext } from "contexts";
import FeaturedDeals from "./lib/FeaturedDeals";
import { PageContent } from "components/PageContent";
import { IShopSection } from "contexts/WebStoreProvider/types";
import { LimitedDealsSection } from "./lib/LimitedDealsSection";
import { selectShopSectionsState } from "redux/slices/shop-sections";
import PageTopNav, { ISectionMenuItem } from "components/PageTopNav";
import { useState, createRef, useEffect, createContext, useRef } from "react";
import { WsDialogs as IDialogVariants } from "interfaces/dialog/variant";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { offersApi, useGetOffersQuery } from "redux/apis";

// eslint-disable-next-line
export const ShopContext = createContext({} as any);

const StoreFront = () => {
	const { shopSections } = useAppSelector(selectShopSectionsState);
	const [sectionMenuData, setSectionMenuData] = useState<ISectionMenuItem[]>(
		[]
	);
	const { authToken, isAutoLoginIn } = useWebStoreContext();
	const [mainShopSections, setShopSections] = useState<IShopSection[]>([]);
	const { variant, openDialog, dialogState, closeDialog } =
		useDialogModalRedux();
	useEffect(() => {
		window?.scrollTo(0, 0);
	}, []);

	const { data: featuredDealsData } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "featured",
			isAuthenticated: !!authToken?.value
		});

	//Prevent rerendering when processing storeRaw
	useEffect(() => {
		if (!shopSections?.mainShopSections) {
			return;
		}
		if (isEqualWith(shopSections?.mainShopSections, mainShopSections)) {
			return;
		}
		setShopSections(shopSections?.mainShopSections);
	}, [shopSections?.mainShopSections]);

	const sectionRefs = useRef<{ [key: number]: React.RefObject<HTMLElement> }>(
		{}
	);
	useEffect(() => {
		const newSectionMenuData = mainShopSections.map((data, index) => {
			const { name, title: text, iconImageUrl: icon } = data;

			const sectionRef = sectionRefs.current[index] || createRef();
			sectionRefs.current[index] = sectionRef;

			return {
				name,
				text,
				icon,
				sectionRef,
				analytics_source: "store"
			};
		});

		setSectionMenuData(newSectionMenuData);
	}, [mainShopSections, featuredDealsData]);

	const isLoginPopup = () =>
		variant === IDialogVariants.LOGIN_TO_CONNECT &&
		dialogState?.source === "shop";

	const isAccountNotConnectedPopup = () =>
		variant === IDialogVariants.ACCOUNT_NOT_CONNECTED;

	useEffect(() => {
		if (!authToken?.value) {
			if (!isAccountNotConnectedPopup() && !isLoginPopup() && !isAutoLoginIn) {
				openDialog(IDialogVariants.LOGIN_TO_CONNECT, { source: "shop" });
			}
		} else if (isLoginPopup()) {
			closeDialog();
		}
	}, [authToken?.value, variant, isAutoLoginIn]);

	return (
		<div
			style={{
				position: "relative",
				filter: authToken?.value ? "none" : "blur(10px)"
				//pointerEvents: authToken?.value ? "auto" : "none"
			}}
		>
			<ShopContext.Provider value={{ sectionMenuData }}>
				<PageTopNav sectionMenuData={sectionMenuData} />
				<PageContent source={"store_page"} enableBackToTop>
					<FeaturedDeals />
					<LimitedDealsSection />
					<SingleItems />
				</PageContent>
			</ShopContext.Provider>
		</div>
	);
};

export default StoreFront;
